import script from "./HeadCell.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadCell.vue?vue&type=script&setup=true&lang=js"

import "./HeadCell.vue?vue&type=style&index=0&id=66874ef7&lang=scss"

export default script